import React from "react";

const UnitsDeliveredIcon = ({ width, height, color }) => {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M41.3456 0.281622C41.8612 0.656408 42.0721 1.15612 41.9784 1.78077L35.9789 37.7602C35.9008 38.2131 35.6508 38.5645 35.229 38.8143C35.0102 38.9392 34.7681 39.0017 34.5025 39.0017C34.3306 39.0017 34.1431 38.9627 33.94 38.8846L21.5896 33.8484L14.6058 41.5081C14.3246 41.836 13.9574 42 13.5043 42C13.2856 42 13.1059 41.9688 12.9653 41.9063C12.6685 41.797 12.4341 41.6135 12.2623 41.3558C12.0904 41.0982 12.0045 40.8132 12.0045 40.5009V29.9131L0.942967 25.3923C0.364893 25.1737 0.0524213 24.7442 0.00555049 24.104C-0.0413203 23.4949 0.208657 23.0343 0.755484 22.7219L39.752 0.234774C40.2988 -0.0931642 40.83 -0.0775481 41.3456 0.281622ZM33.3307 35.3944L38.5099 4.40427L4.90355 23.776L12.7778 26.9851L33.0026 12.0171L21.8005 30.6861L33.3307 35.3944Z"
        fill="#435CFF"
      />
    </svg>
  );
};

export default UnitsDeliveredIcon;
